import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import { useLanguages } from '~/composables';
import UiSelect from '~/components/ui/UiSelect.vue';
import UiSelectOption from '~/components/ui/UiSelectOption.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopbarLanguage',
  setup(__props) {

const { i18n } = useContext();
const { languages } = useLanguages();

const envLocalesSet = new Set(
  i18n.locales.map((locale) => {
    if (typeof locale === 'string') {
      return locale;
    }
    return locale.code;
  }),
);

const availableLanguages = computed(() => {
  return languages.filter(
    (language: { code: string; default: boolean; name: string }) =>
      envLocalesSet.has(language.code),
  );
});

const isShowed = computed(() => availableLanguages.value.length > 1);

const getLangUrl = (lang: string) => `/${lang}`;
const handleSelect = (e: any) => i18n.setLocale(e);

return { __sfc: true,i18n, languages, envLocalesSet, availableLanguages, isShowed, getLangUrl, handleSelect, UiSelect, UiSelectOption }
}

})